import { PermissionsRiskLevelSummaryFieldsFragment, ResourceNodeFieldsFragment } from '@api/gql/graphql';
import { getFragmentData } from '@api/gql';
import { INTEGRATION_FRAGMENT, RESOURCE_TYPE_FRAGMENT } from '@AccessRightSizing/services/gql';
import { STATUS_FIELD_FRAGMENT } from '@Inventory/services/gql';
import { TableCell, TableRow, Tooltip, Typography } from '@mui/material';
import PrimarySecondary from '@common/ui/PrimarySecondary';
import StatusIcon from '@common/ui/StatusIcon';
import { useFlagFixed } from '@hooks';
import { Flag } from '@utils';
import { riskLevelFields_Fragment } from '@AccessAlerts/services/gql';
import { RiskScoreSummary } from './RiskScoreSummary';
import { getEntitlementsCount } from '@Inventory/common/utils';

export function InventoryTableRow({
  resource,
  entitlementsCount,
  permissionsCount,
  permissionsRiskLevelSummary,
  onClick,
  selected,
}: {
  resource: ResourceNodeFieldsFragment;
  entitlementsCount?: number;
  permissionsCount?: number;
  permissionsRiskLevelSummary?: PermissionsRiskLevelSummaryFieldsFragment;
  onClick?: () => void;
  selected?: boolean;
}) {
  const { isEnabled: isRiskScoreEnabled } = useFlagFixed(Flag.SHOW_RISK_SCORE);
  const integrationData = getFragmentData(INTEGRATION_FRAGMENT, resource.integration);
  const typeData = getFragmentData(RESOURCE_TYPE_FRAGMENT, resource.type);
  const statusData = getFragmentData(STATUS_FIELD_FRAGMENT, resource.status);
  const riskLevel = getFragmentData(riskLevelFields_Fragment, resource.riskLevel);

  const displayEntitlementsCount = getEntitlementsCount(entitlementsCount, permissionsCount);

  return (
    <TableRow onClick={onClick} hover className="MuiTableRow-clickable" selected={selected}>
      <TableCell>
        <PrimarySecondary
          primary={resource.name}
          secondary={`${resource.sourceId}`}
          icon={
            <Tooltip title={statusData.message}>
              <div>
                <StatusIcon status={statusData.status} />
              </div>
            </Tooltip>
          }
        />
      </TableCell>
      <TableCell>
        <Typography variant="body2">{displayEntitlementsCount}</Typography>
      </TableCell>
      <TableCell>
        {isRiskScoreEnabled && permissionsRiskLevelSummary && riskLevel?.riskLevel && (
          <RiskScoreSummary
            permissionsRiskLevelSummary={permissionsRiskLevelSummary}
            resourceRiskLevel={riskLevel?.riskLevel}
          />
        )}
      </TableCell>
      <TableCell>
        {integrationData && (
          <PrimarySecondary
            primary={integrationData.name}
            secondary={integrationData.type}
            icon={integrationData.icons?.svg}
          />
        )}
      </TableCell>
      <TableCell>
        {typeData && <PrimarySecondary primary={typeData.typeDisplayName} icon={typeData.icons?.svg} />}
      </TableCell>
    </TableRow>
  );
}
